module.exports = __webpack_public_path__ + "img/mountedcrane_parked.f3ab67de.svg";